module.exports = __webpack_public_path__ + "img/MaxPag.5891c977.png";